import Table, { TableProps } from "components/Table";

import cn from "lib/cn";

const TableScrollable = ({ containerClassName, ...props }: TableProps) => {
  return (
    <Table
      fixedHeight
      containerClassName={cn("h-[calc(100vh-17.5rem)]", containerClassName)}
      {...props}
    />
  );
};

export default TableScrollable;
